import { render } from "./GameResult.vue?vue&type=template&id=8544ec48&scoped=true"
import script from "./GameResult.vue?vue&type=script&lang=js"
export * from "./GameResult.vue?vue&type=script&lang=js"

import "./GameResult.vue?vue&type=style&index=0&id=8544ec48&scoped=true&lang=css"

import exportComponent from "/Users/vaclavsmital/Projects/geoword/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8544ec48"]])

export default __exports__